import script from "./LoginReserva.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginReserva.vue?vue&type=script&setup=true&lang=js"

import "./LoginReserva.vue?vue&type=style&index=0&id=918b0978&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-918b0978"]])

export default __exports__